export default {
    name: '',
    sort: 0,
};
